var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartReservationWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77235 8.35892C2.8412 8.14613 3.05602 8 3.3 8H7.7C7.87679 8 8.04281 8.07726 8.14618 8.20764C8.24955 8.33803 8.27768 8.50564 8.22178 8.65811L6.26308 14H10.45C10.6601 14 10.8518 14.1088 10.9441 14.2803C11.0364 14.4519 11.0131 14.6562 10.8841 14.807L3.18415 23.8069C3.02114 23.9975 2.73167 24.0549 2.49614 23.9435C2.2606 23.8321 2.14624 23.5836 2.22432 23.3529L4.20532 17.5H0.550004C0.376669 17.5 0.213477 17.4257 0.109632 17.2995C0.00578803 17.1734 -0.0265556 17.0101 0.0223536 16.8589L2.77235 8.35892Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C16.1046 16 17 15.1046 17 14H13C13 15.1046 13.8954 16 15 16Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9952 1.09903C15.9984 1.06646 16 1.03342 16 1C16 0.447715 15.5523 0 15 0C14.4477 0 14 0.447715 14 1C14 1.03342 14.0016 1.06646 14.0048 1.09904C11.7202 1.56045 10 3.57934 10 6C10 7.0976 9.5 12 8 13H22C20.5 12 20 7.0976 20 6C20 3.57932 18.2798 1.56042 15.9952 1.09903Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartReservationWhite);
export default __webpack_public_path__ + "static/media/smart-reservation-white.3e3cf3c8ce1407e6758d72422050b134.svg";
export { ForwardRef as ReactComponent };